import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { apiFetch, ApiRequestError } from "../api/client";
import type { User } from "../api/contract";
import { queryKeys } from "../api/queries";
import { Alert } from "../components/ui/Alert";
import { Planner } from "../features/planner/Planner";
import { EmailActionPage, LoginPage, PasswordPage, VerifyPage } from "../features/auth/Auth";
import { Dashboard } from "../features/dashboard";

function Placeholder({ title, eyebrow }: { title: string; eyebrow: string }) {
  return <section className="hero"><p className="eyebrow">{eyebrow}</p><h1>{title}</h1><p className="lede">This route is ready for its feature module.</p></section>;
}

export function HomeRoute() { return <Planner />; }
export function AuthRoute() {
  const path = useLocation().pathname;
  if (path === "/auth/login") return <LoginPage />;
  if (path === "/auth/register") return <PasswordPage invitation />;
  if (path === "/auth/reset-password") return <PasswordPage invitation={false} />;
  if (path === "/auth/verify") return <VerifyPage />;
  if (path === "/auth/forgot-password") return <EmailActionPage resend={false} />;
  if (path === "/auth/resend-verification") return <EmailActionPage resend />;
  return <Placeholder eyebrow="Your account" title="Account access" />;
}
export function DashboardRoute() { return <Dashboard />; }

export function ProtectedRoute() {
  const location = useLocation();
  const query = useQuery({ queryKey: queryKeys.me, queryFn: () => apiFetch<User>("/api/auth/me"), retry: false });
  if (query.isPending) return <div className="route-status" role="status">Checking your session…</div>;
  if (query.error instanceof ApiRequestError && query.error.status === 401) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }
  if (query.isError) return <Alert tone="error">We couldn’t check your session. Please try again.</Alert>;
  return <Outlet />;
}
